import React from "react";
import { formatDateTime, getActionBadgeClass, formatLocation } from "./utils";

function LogTable({
  logs,
  loading,
  selectedLog,
  onSelectLog,
  pagination,
  onPageChange,
}) {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3 pb-0">
        <h5 className="card-title fw-bold mb-0">Logs List</h5>
        <span className="badge bg-light text-dark border">
          {logs.length} logs found
        </span>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col">Date/Time</th>
                <th scope="col">Action</th>
                <th scope="col">Booking ID</th>
                <th scope="col">User ID</th>
                <th scope="col">IP</th>
                <th scope="col">Location</th>
                <th scope="col">Device Info</th>
                <th scope="col">Path</th>
                <th scope="col" className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center py-5">
                    <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                    <span className="text-muted">Loading audit logs...</span>
                  </td>
                </tr>
              ) : logs.length > 0 ? (
                logs.map((log) => (
                  <tr
                    key={log.id}
                    className={selectedLog?.id === log.id ? "table-primary" : ""}
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectLog(log)}
                  >
                    <td className="text-nowrap">{formatDateTime(log.createdAt)}</td>
                    <td>
                      <span className={`badge ${getActionBadgeClass(log.action)}`}>
                        {log.action}
                      </span>
                    </td>
                    <td className="fw-semibold">
                      {log.meta?.bookingId || log.bookingId || "-"}
                    </td>
                    <td>{log.userId || "-"}</td>
                    <td className="text-nowrap">{log.ip || "-"}</td>
                    <td>
                      <span className="small text-muted">{formatLocation(log.location)}</span>
                    </td>
                    <td>
                      {log.deviceInfo ? (
                        <div className="small text-muted text-nowrap">
                          {log.deviceInfo.os} / {log.deviceInfo.browser}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-truncate" style={{ maxWidth: "150px" }} title={log.path}>
                      <code>{log.path}</code>
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className={`btn btn-xs ${
                          selectedLog?.id === log.id ? "btn-primary" : "btn-outline-primary"
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onSelectLog(log);
                        }}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-5 text-muted">
                    No audit logs found with current filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Section */}
        {logs.length > 0 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <div className="text-muted small">
              Showing {logs.length > 0 ? (pagination.page - 1) * pagination.limit + 1 : 0} to{" "}
              {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} entries
            </div>
            {pagination.totalPages > 1 && (
              <nav aria-label="Logs pagination">
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${pagination.page === 1 ? "disabled" : ""}`}>
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => onPageChange(pagination.page - 1)}
                      disabled={pagination.page === 1}
                    >
                      Previous
                    </button>
                  </li>
                  {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => {
                    if (p === 1 || p === pagination.totalPages || Math.abs(p - pagination.page) <= 1) {
                      return (
                        <li key={p} className={`page-item ${pagination.page === p ? "active" : ""}`}>
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => onPageChange(p)}
                          >
                            {p}
                          </button>
                        </li>
                      );
                    }
                    if (p === 2 || p === pagination.totalPages - 1) {
                      return (
                        <li key={p} className="page-item disabled" style={{ cursor: "default" }}>
                          <span className="page-link">...</span>
                        </li>
                      );
                    }
                    return null;
                  })}
                  <li className={`page-item ${pagination.page === pagination.totalPages ? "disabled" : ""}`}>
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => onPageChange(pagination.page + 1)}
                      disabled={pagination.page === pagination.totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default LogTable;
